/**
 * @generated SignedSource<<e3fb056c3a24c58576e4df4c914cf639>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type quoteRuleEditor_QuoteRuleDetailQuery$variables = {
  id: string;
};
export type quoteRuleEditor_QuoteRuleDetailQuery$data = {
  readonly quoteRule: {
    readonly allowAddToCart: boolean;
    readonly formControlsData: string | null;
    readonly id: string;
    readonly isValidForAllProducts: boolean;
    readonly name: string | null;
    readonly notifyEmailList: string | null;
    readonly products: ReadonlyArray<number> | null;
    readonly quoteRuleID: number;
  };
};
export type quoteRuleEditor_QuoteRuleDetailQuery = {
  response: quoteRuleEditor_QuoteRuleDetailQuery$data;
  variables: quoteRuleEditor_QuoteRuleDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "QuoteRule",
    "kind": "LinkedField",
    "name": "quoteRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quoteRuleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowAddToCart",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "notifyEmailList",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isValidForAllProducts",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "formControlsData",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "products",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "quoteRuleEditor_QuoteRuleDetailQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "quoteRuleEditor_QuoteRuleDetailQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b6742bb8e289725ac6b9c2667ef66e19",
    "id": null,
    "metadata": {},
    "name": "quoteRuleEditor_QuoteRuleDetailQuery",
    "operationKind": "query",
    "text": "query quoteRuleEditor_QuoteRuleDetailQuery(\n  $id: String!\n) {\n  quoteRule(id: $id) {\n    id\n    quoteRuleID\n    name\n    allowAddToCart\n    notifyEmailList\n    isValidForAllProducts\n    formControlsData\n    products\n  }\n}\n"
  }
};
})();

(node as any).hash = "a6a384fd44430bff3623386e077273d1";

export default node;
